export default "__VITE_ASSET__D6mM07At__"